import * as types from './mutation-types';
import EventBus from '@/utils/eventBus';
import productService from '@/services/product';

export const getStatuses = async ({ commit, state }) => {
  if (state.product.statuses.length !== 0) {
    return commit(types.GET_STATUSES);
  }
  const states = await productService.states();
  return commit(types.GET_STATUSES, states);
};

export const getProducts = ({ commit, state }, filter) => {
  EventBus.$emit('show-loading', true);
  if (!filter && state.lastFilter) {
    filter = state.lastFilter;
  }

  productService.countAll().then((i) => {
    productService.get(filter).then((res) => {
      EventBus.$emit('show-loading', false);
      commit(types.GET_PRODUCTS, {
        lastFilter: filter,
        products: res.data,
        count: i.data.count,
      });
    });
  });
};


export default {
  getStatuses,
  getProducts,
};



// WEBPACK FOOTER //
// ./src/store/modules/product/actions.js